/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * NoteRoleEnum
 * A role code as ``notes.author_role`` and ``notes.audience`` spell it.
 *
 * The same four codes ``app.entity_role`` carries, so an RLS predicate is a
 * literal ``= ANY(audience)``. ``ofa`` is deliberately absent: an office
 * administrator's session runs as ``adm`` (see
 * ``homecare.utils.request_context.ADMIN_DATA_ROLES``), so a note it writes is
 * authored by ``adm`` and the CHECK constraint would refuse anything else.
 */
export enum NoteRoleEnum {
  Adm = 'adm',
  Cgv = 'cgv',
  Doc = 'doc',
  Clt = 'clt',
}

/**
 * NoteKindEnum
 * What a ``notes`` row is, mirroring ``enum_note_kind``.
 *
 * ``VISIT_NOTE`` is a record about the work; ``MESSAGE`` is addressed to
 * someone and is the only kind that notifies. The distinction is NOT who may
 * read the row - that is ``audience``.
 */
export enum NoteKindEnum {
  VISIT_NOTE = 'VISIT_NOTE',
  MESSAGE = 'MESSAGE',
}

/** MobilityEnum */
export enum MobilityEnum {
  INDEPENDENT = 'INDEPENDENT',
  INDEPENDENT_WITH_ASSISTIVE_DEVICE = 'INDEPENDENT_WITH_ASSISTIVE_DEVICE',
  ASSISTED = 'ASSISTED',
  WHEELCHAIR = 'WHEELCHAIR',
  BEDBOUND = 'BEDBOUND',
}

/** GenderEnum */
export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

/** DoctorTypeEnum */
export enum DoctorTypeEnum {
  ATTENDING = 'ATTENDING',
  REFERRING = 'REFERRING',
}

/** ContactTypeEnum */
export enum ContactTypeEnum {
  EMERGENCY = 'EMERGENCY',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

/**
 * CaregiverNoteFlagEnum
 * How a caregiver's visit note should be read.
 *
 * Mirrors ``visits.caregiver_note_flag``. There is deliberately no member for
 * "unclassified": that is the column's NULL, and an unflagged note is not a
 * ROUTINE one - nothing has judged it yet.
 */
export enum CaregiverNoteFlagEnum {
  ATTENTION = 'ATTENTION',
  INFO = 'INFO',
  ROUTINE = 'ROUTINE',
}

/**
 * AttachmentKindEnum
 * What an attached file is, for the client folder's filters.
 *
 * Mirrors ``attachments.kind``. NULL there means unclassified, so callers
 * bucket those files by content type rather than picking a kind for them.
 */
export enum AttachmentKindEnum {
  REPORT = 'REPORT',
  PHOTO = 'PHOTO',
  LAB = 'LAB',
  PRESCRIPTION = 'PRESCRIPTION',
  INVOICE = 'INVOICE',
  CARE_PLAN = 'CARE_PLAN',
}

/** AddressComponent */
export interface AddressComponent {
  /**
   * Long Name
   * @default ""
   */
  long_name?: string;
  /**
   * Short Name
   * @default ""
   */
  short_name?: string;
  /** Types */
  types?: string[];
}

/** AttachmentBase */
export interface AttachmentBase {
  /** Attachmentid */
  attachmentId: number;
  /** Filename */
  filename: string;
  /** Contenttype */
  contentType?: string | null;
  /**
   * Uploadedat
   * @format date-time
   */
  uploadedAt: string;
  /** Description */
  description?: string | null;
  /** Thumbnail */
  thumbnail?: string | null;
  kind?: AttachmentKindEnum | null;
}

/** AttachmentCreateResponse */
export interface AttachmentCreateResponse {
  /** Attachmentid */
  attachmentId: number;
}

/**
 * AttachmentUpdate
 * What may be changed about a file after it has been uploaded.
 *
 * The bytes are immutable: replacing a file's content is a new upload, so what is
 * editable is how it is described. Both fields are optional and the routers write
 * only the ones the caller actually sent - `exclude_unset` - so clearing a kind is
 * `{"kind": null}` and leaving it alone is omitting the key. Without that
 * distinction, correcting a description would silently drop the kind.
 */
export interface AttachmentUpdate {
  kind?: AttachmentKindEnum | null;
  /** Description */
  description?: string | null;
}

/** AttachmentWithContent */
export interface AttachmentWithContent {
  /** Attachmentid */
  attachmentId: number;
  /** Filename */
  filename: string;
  /** Contenttype */
  contentType?: string | null;
  /**
   * Uploadedat
   * @format date-time
   */
  uploadedAt: string;
  /** Description */
  description?: string | null;
  /** Thumbnail */
  thumbnail?: string | null;
  kind?: AttachmentKindEnum | null;
  /**
   * Content
   * Base64-encoded file content
   */
  content?: string | null;
  /** Visitid */
  visitId?: number | null;
}

/** Body_createClientAttachment */
export interface BodyCreateClientAttachment {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Description
   * Optional description of the attachment
   */
  description?: string | null;
  /** What the file is, for the client folder's filters. Omit to leave it unclassified. */
  kind?: AttachmentKindEnum | null;
}

/** Body_importClientsCommit */
export interface BodyImportClientsCommit {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Update
   * @default false
   */
  update?: boolean;
}

/** Body_importClientsPreview */
export interface BodyImportClientsPreview {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Update
   * @default false
   */
  update?: boolean;
}

/** CaregiverServiceRequestResponse */
export interface CaregiverServiceRequestResponse {
  /** Caregiverid */
  caregiverId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
}

/**
 * Client
 * Model returned from DB (e.g. INSERT … RETURNING * or SELECT)
 */
export interface Client {
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Socialsecurityid */
  socialSecurityId?: string | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Userid */
  userId?: number | null;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Medicalhistory */
  medicalHistory?: string | null;
  /** Medications */
  medications?: string[] | null;
  /** Allergies */
  allergies?: string[] | null;
  mobility?: MobilityEnum | null;
  /** Preferredlanguage */
  preferredLanguage?: string | null;
  /** Favoritecaregivers */
  favoriteCaregivers?: number[] | null;
  /**
   * Categoryids
   * @default []
   */
  categoryIds?: number[];
  /** Notes */
  notes?: string | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Deceased
   * @default false
   */
  deceased?: boolean;
  /** Clientid */
  clientId: number;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /** Contacts */
  contacts?: ClientContact[] | null;
  /** Doctors */
  doctors?: ClientDoctorInClient[] | null;
}

/**
 * ClientBulkChanges
 * The fields a bulk edit may replace, all optional.
 *
 * Read with `model_dump(exclude_unset=True)`: an absent key means "leave this alone".
 * Identity, contact and address fields are absent on purpose, and `extra="forbid"` makes
 * sending one a 400. City is excluded because changing it alone strands street and geo.
 */
export interface ClientBulkChanges {
  /** Categoryids */
  categoryIds?: number[] | null;
  /** Active */
  active?: boolean | null;
  /** Deceased */
  deceased?: boolean | null;
  /** Preferredlanguage */
  preferredLanguage?: string | null;
  mobility?: MobilityEnum | null;
  /** Medications */
  medications?: string[] | null;
  /** Allergies */
  allergies?: string[] | null;
  /** Medicalhistory */
  medicalHistory?: string | null;
}

/** ClientBulkUpdateRequest */
export interface ClientBulkUpdateRequest {
  /**
   * Clientids
   * @maxItems 1000
   * @minItems 1
   */
  clientIds: number[];
  /**
   * The fields a bulk edit may replace, all optional.
   *
   * Read with `model_dump(exclude_unset=True)`: an absent key means "leave this alone".
   * Identity, contact and address fields are absent on purpose, and `extra="forbid"` makes
   * sending one a 400. City is excluded because changing it alone strands street and geo.
   */
  changes: ClientBulkChanges;
}

/** ClientBulkUpdateResponse */
export interface ClientBulkUpdateResponse {
  /** Updatedcount */
  updatedCount: number;
  /** Notfoundids */
  notFoundIds?: number[];
}

/** ClientCategoriesGetAllPaginationResponse */
export interface ClientCategoriesGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ClientCategory[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/**
 * ClientCategory
 * Model representing a client category returned from the database.
 */
export interface ClientCategory {
  /**
   * Name
   * Name of the client category
   */
  name: string;
  /**
   * Description
   * Detailed description of the client category
   */
  description?: string | null;
  /**
   * Clientcategoryid
   * Unique identifier for the client category (PK)
   */
  clientCategoryId: number;
  /** Createdat */
  createdAt?: string | null;
}

/**
 * ClientCategoryCreate
 * Schema for creating a new client category.
 */
export interface ClientCategoryCreate {
  /**
   * Name
   * Name of the client category
   */
  name: string;
  /**
   * Description
   * Detailed description of the client category
   */
  description?: string | null;
}

/**
 * ClientCategoryUpdate
 * Schema for updating an existing client category.
 */
export interface ClientCategoryUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
}

/**
 * ClientContact
 * Model for client contact returned from database
 */
export interface ClientContact {
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Relationship */
  relationship?: string | null;
  contactType: ContactTypeEnum;
  /** Notes */
  notes?: string | null;
  /** Clientcontactid */
  clientContactId: number;
  /** Clientid */
  clientId: number;
}

/**
 * ClientContactCreate
 * Payload for creating a new client contact
 */
export interface ClientContactCreate {
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Relationship */
  relationship?: string | null;
  contactType: ContactTypeEnum;
  /** Notes */
  notes?: string | null;
}

/**
 * ClientContactUpsert
 * Payload for syncing client contacts from client updates
 */
export interface ClientContactUpsert {
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Relationship */
  relationship?: string | null;
  contactType: ContactTypeEnum;
  /** Notes */
  notes?: string | null;
  /** Clientcontactid */
  clientContactId?: number | null;
}

/**
 * ClientCreate
 * Payload for POST /clients — required fields per SQL (NOT NULL)
 */
export interface ClientCreate {
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Socialsecurityid */
  socialSecurityId?: string | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Userid */
  userId?: number | null;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Medicalhistory */
  medicalHistory?: string | null;
  /** Medications */
  medications?: string[] | null;
  /** Allergies */
  allergies?: string[] | null;
  mobility?: MobilityEnum | null;
  /** Preferredlanguage */
  preferredLanguage?: string | null;
  /** Favoritecaregivers */
  favoriteCaregivers?: number[] | null;
  /**
   * Categoryids
   * @default []
   */
  categoryIds?: number[];
  /** Notes */
  notes?: string | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Deceased
   * @default false
   */
  deceased?: boolean;
  /** Contacts */
  contacts?: ClientContactCreate[] | null;
  /** Doctors */
  doctors?: HomecareModelsClientsClientDoctorCreate[] | null;
}

/**
 * ClientDoctorInClient
 * Client doctor info returned within client (with populated doctor details)
 */
export interface ClientDoctorInClient {
  /** Clientdoctorid */
  clientDoctorId: number;
  /** Doctorid */
  doctorId: number;
  doctorType: DoctorTypeEnum;
  /**
   * Startdate
   * @format date
   */
  startDate: string;
  /** Enddate */
  endDate?: string | null;
  /**
   * Takescommission
   * @default true
   */
  takesCommission?: boolean;
  /** Commissionrate */
  commissionRate?: number | null;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /** Doctorfirstname */
  doctorFirstName?: string | null;
  /** Doctorlastname */
  doctorLastName?: string | null;
  /** Doctoremail */
  doctorEmail?: string | null;
  /** Doctorphonemobile */
  doctorPhoneMobile?: string | null;
  /** Doctorspecialization */
  doctorSpecialization?: string | null;
}

/**
 * ClientDoctorPopulated
 * Client doctor with populated doctor information
 */
export interface ClientDoctorPopulated {
  /**
   * Clientid
   * ID of the client
   */
  clientId: number;
  /**
   * Doctorid
   * ID of the doctor
   */
  doctorId: number;
  /** Type of doctor (ATTENDING or REFERRING) */
  doctorType: DoctorTypeEnum;
  /**
   * Startdate
   * Start date of the doctor-client relationship
   * @format date
   */
  startDate: string;
  /**
   * Enddate
   * End date of the relationship (NULL if active)
   */
  endDate?: string | null;
  /**
   * Takescommission
   * Whether this client-doctor assignment pays commission for the covered period
   * @default true
   */
  takesCommission?: boolean;
  /**
   * Commissionrate
   * Commission percentage override for this assignment period (0-100). NULL falls back to doctor default
   */
  commissionRate?: number | null;
  /** Clientdoctorid */
  clientDoctorId: number;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /** Doctorfirstname */
  doctorFirstName?: string | null;
  /** Doctorlastname */
  doctorLastName?: string | null;
  /** Doctoremail */
  doctorEmail?: string | null;
  /** Doctorphonemobile */
  doctorPhoneMobile?: string | null;
  /** Doctorspecialization */
  doctorSpecialization?: string | null;
}

/**
 * ClientDoctorUpdate
 * PATCH/PUT payload – all fields optional (dump with exclude_unset=True)
 */
export interface ClientDoctorUpdate {
  /**
   * Doctorid
   * ID of the doctor
   */
  doctorId?: number | null;
  /** Type of doctor (ATTENDING or REFERRING) */
  doctorType?: DoctorTypeEnum | null;
  /**
   * Startdate
   * Start date of the doctor-client relationship
   */
  startDate?: string | null;
  /**
   * Enddate
   * End date of the relationship (NULL if active)
   */
  endDate?: string | null;
  /**
   * Takescommission
   * Whether this client-doctor assignment pays commission for the covered period
   */
  takesCommission?: boolean | null;
  /**
   * Commissionrate
   * Commission percentage override for this assignment period (0-100)
   */
  commissionRate?: number | null;
}

/**
 * ClientDoctorUpsert
 * Payload for syncing client-doctor relationships from client updates
 */
export interface ClientDoctorUpsert {
  /**
   * Doctorid
   * ID of the doctor
   */
  doctorId: number;
  /** Type of doctor (ATTENDING or REFERRING) */
  doctorType: DoctorTypeEnum;
  /**
   * Startdate
   * Start date of the doctor-client relationship
   * @format date
   */
  startDate: string;
  /**
   * Enddate
   * End date of the relationship (NULL if active)
   */
  endDate?: string | null;
  /**
   * Takescommission
   * Whether this client-doctor assignment pays commission for the covered period
   * @default true
   */
  takesCommission?: boolean;
  /**
   * Commissionrate
   * Commission percentage override for this assignment period (0-100). NULL falls back to doctor default
   */
  commissionRate?: number | null;
  /** Clientdoctorid */
  clientDoctorId?: number | null;
}

/** ClientMinified */
export interface ClientMinified {
  /** Clientid */
  clientId: number | null;
  /** Firstname */
  firstName?: string | null;
  /** Lastname */
  lastName?: string | null;
  /** City */
  city?: string | null;
  /** Street */
  street?: string | null;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
}

/**
 * ClientPopulated
 * Model returned from DB with populated doctor information
 */
export interface ClientPopulated {
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Socialsecurityid */
  socialSecurityId?: string | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Userid */
  userId?: number | null;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Medicalhistory */
  medicalHistory?: string | null;
  /** Medications */
  medications?: string[] | null;
  /** Allergies */
  allergies?: string[] | null;
  mobility?: MobilityEnum | null;
  /** Preferredlanguage */
  preferredLanguage?: string | null;
  /** Favoritecaregivers */
  favoriteCaregivers?: number[] | null;
  /**
   * Categoryids
   * @default []
   */
  categoryIds?: number[];
  /** Notes */
  notes?: string | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Deceased
   * @default false
   */
  deceased?: boolean;
  /** Clientid */
  clientId: number;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /** Contacts */
  contacts?: ClientContact[] | null;
  /** Doctors */
  doctors?: ClientDoctorInClient[] | null;
  referringDoctor?: DoctorMinified | null;
  attendingDoctor?: DoctorMinified | null;
}

/**
 * ClientUpdate
 * PATCH/PUT payload – all fields optional (dump with exclude_unset=True)
 */
export interface ClientUpdate {
  /** Firstname */
  firstName?: string | null;
  /** Lastname */
  lastName?: string | null;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Socialsecurityid */
  socialSecurityId?: string | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Userid */
  userId?: number | null;
  /** Street */
  street?: string | null;
  /** City */
  city?: string | null;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Medicalhistory */
  medicalHistory?: string | null;
  /** Medications */
  medications?: string[] | null;
  /** Allergies */
  allergies?: string[] | null;
  mobility?: MobilityEnum | null;
  /** Preferredlanguage */
  preferredLanguage?: string | null;
  /** Favoritecaregivers */
  favoriteCaregivers?: number[] | null;
  /**
   * Categoryids
   * @default []
   */
  categoryIds?: number[];
  /** Notes */
  notes?: string | null;
  /** Active */
  active?: boolean | null;
  /** Deceased */
  deceased?: boolean | null;
  /** Contacts */
  contacts?: ClientContactUpsert[] | null;
  /** Doctors */
  doctors?: ClientDoctorUpsert[] | null;
}

/** ClientWithHistory */
export interface ClientWithHistory {
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Socialsecurityid */
  socialSecurityId?: string | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Userid */
  userId?: number | null;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Medicalhistory */
  medicalHistory?: string | null;
  /** Medications */
  medications?: string[] | null;
  /** Allergies */
  allergies?: string[] | null;
  mobility?: MobilityEnum | null;
  /** Preferredlanguage */
  preferredLanguage?: string | null;
  /** Favoritecaregivers */
  favoriteCaregivers?: number[] | null;
  /**
   * Categoryids
   * @default []
   */
  categoryIds?: number[];
  /** Notes */
  notes?: string | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Deceased
   * @default false
   */
  deceased?: boolean;
  /** Clientid */
  clientId: number;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /** Contacts */
  contacts?: ClientContact[] | null;
  /** Doctors */
  doctors?: ClientDoctorInClient[] | null;
  /** Visits */
  visits: VisitHistory[];
}

/**
 * ClientsGetAllMinifiedPaginationResponse
 * Client with pagination
 */
export interface ClientsGetAllMinifiedPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ClientMinified[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/**
 * ClientsGetAllPaginationResponse
 * Client with pagination
 */
export interface ClientsGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ClientPopulated[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/**
 * DoctorMinified
 * Minimal doctor info for client display
 */
export interface DoctorMinified {
  /** Doctorid */
  doctorId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
}

/** ExportColumnRequest */
export interface ExportColumnRequest {
  /** Key */
  key: string;
  /** Header */
  header: string;
}

/** ExportRequest */
export interface ExportRequest {
  /** Format */
  format: 'csv' | 'xlsx';
  /**
   * Columns
   * @maxItems 200
   * @minItems 1
   */
  columns: ExportColumnRequest[];
  /** Params */
  params?: Record<string, any>;
}

/** ExportStarted */
export interface ExportStarted {
  /** Exportid */
  exportId: number;
}

/** GlobalSearchResponse */
export interface GlobalSearchResponse {
  /** Groups */
  groups: SearchGroup[];
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** ImportCounts */
export interface ImportCounts {
  /**
   * Create
   * @default 0
   */
  create?: number;
  /**
   * Update
   * @default 0
   */
  update?: number;
  /**
   * Skip
   * @default 0
   */
  skip?: number;
  /**
   * Errors
   * @default 0
   */
  errors?: number;
  /**
   * Warnings
   * @default 0
   */
  warnings?: number;
}

/** ImportIssue */
export interface ImportIssue {
  /** Sheet */
  sheet: string;
  /** Row */
  row?: number | null;
  /** Column */
  column?: string | null;
  /** Message */
  message: string;
  /**
   * Level
   * @default "error"
   */
  level?: 'error' | 'warning';
}

/** ImportReport */
export interface ImportReport {
  /**
   * Committed
   * @default false
   */
  committed?: boolean;
  counts: ImportCounts;
  /** Rows */
  rows: ImportRowResult[];
  /** Issues */
  issues: ImportIssue[];
}

/** ImportRowResult */
export interface ImportRowResult {
  /** Sheet */
  sheet: string;
  /** Row */
  row: number;
  /** Label */
  label: string;
  /** Action */
  action: 'create' | 'update' | 'skip' | 'error';
}

/**
 * Note
 * One note as it is read back.
 *
 * Flat rather than nested: the author is three sibling fields, not an object.
 * Two of them can be absent and the third never is, which is the shape the
 * data actually has - a nested object would have to exist with every field
 * null for a migrated legacy row.
 */
export interface Note {
  /** Noteid */
  noteId: number;
  /** Clientid */
  clientId: number;
  /** Visitid */
  visitId?: number | null;
  /**
   * What a ``notes`` row is, mirroring ``enum_note_kind``.
   *
   * ``VISIT_NOTE`` is a record about the work; ``MESSAGE`` is addressed to
   * someone and is the only kind that notifies. The distinction is NOT who may
   * read the row - that is ``audience``.
   */
  kind: NoteKindEnum;
  /** Authoruserid */
  authorUserId?: number | null;
  /**
   * A role code as ``notes.author_role`` and ``notes.audience`` spell it.
   *
   * The same four codes ``app.entity_role`` carries, so an RLS predicate is a
   * literal ``= ANY(audience)``. ``ofa`` is deliberately absent: an office
   * administrator's session runs as ``adm`` (see
   * ``homecare.utils.request_context.ADMIN_DATA_ROLES``), so a note it writes is
   * authored by ``adm`` and the CHECK constraint would refuse anything else.
   */
  authorRole: NoteRoleEnum;
  /** Authorname */
  authorName?: string | null;
  /** Audience */
  audience: NoteRoleEnum[];
  /** Body */
  body: string;
  flag?: CaregiverNoteFlagEnum | null;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /**
   * Isread
   * @default false
   */
  isRead?: boolean;
}

/**
 * NoteCreate
 * A new note.
 *
 * ``client_id`` comes from the path and ``author_user_id`` / ``author_role``
 * from the session - never from the body. RLS pins the last two with a WITH
 * CHECK, so a payload that tried to name them would be refused by the database
 * anyway; leaving them off the model means the refusal never has to happen.
 */
export interface NoteCreate {
  /**
   * VISIT_NOTE records the work; MESSAGE is addressed to someone and is the only kind that notifies. It does not decide who may read the note - `audience` does.
   * @default "VISIT_NOTE"
   */
  kind?: NoteKindEnum;
  /**
   * Visitid
   * The visit this note is about. Omit it for a client-level note, which is not tied to any one visit.
   */
  visitId?: number | null;
  /**
   * Body
   * The note itself. Must not be blank.
   */
  body: string;
  /**
   * Audience
   * Role codes allowed to read this note. At least one. This is what row-level security matches on, so narrowing it is how a note is kept from a caregiver or a client.
   */
  audience?: NoteRoleEnum[];
  /** How the note should be read. None is unclassified - the state every note is in until someone judges it - and is NOT a synonym for ROUTINE. */
  flag?: CaregiverNoteFlagEnum | null;
}

/**
 * NoteReadRequest
 * The batch a caller is marking read.
 *
 * A list rather than one id per request because the panel marks everything it
 * just rendered, which is one round trip for a screenful instead of twenty.
 */
export interface NoteReadRequest {
  /**
   * Noteids
   * The notes to mark read for the calling user
   * @maxItems 1000
   */
  noteIds: number[];
}

/**
 * NoteReadResult
 * How many receipts the call actually wrote.
 *
 * Lower than what was asked whenever a note was already read or is not visible
 * to the caller. Reported rather than raised: marking an already-read note read
 * is not an error, and refusing the batch because one id in it was invisible
 * would tell the caller that the note exists.
 */
export interface NoteReadResult {
  /** Marked */
  marked: number;
}

/**
 * NoteUnreadCount
 * The unread badge.
 */
export interface NoteUnreadCount {
  /** Unread */
  unread: number;
}

/**
 * NoteUpdate
 * What may change after the fact.
 *
 * Both fields are optional and are enforced by DIFFERENT rules: the author may
 * rewrite ``body``, and anyone who may update the row (an administrator, per
 * ``notes_update_policy``) may set ``flag``. The split is enforced by
 * ``trg_notes_author_only_body`` in Postgres, not here - RLS cannot restrict a
 * column, and a check that lived only in Python would be one an HTTP caller
 * could not rely on.
 */
export interface NoteUpdate {
  /**
   * Body
   * The author's own text. Only the author may change it.
   */
  body?: string | null;
  /** How the note reads. An administrator may set this on someone else's note; that is the only field they may change on one. */
  flag?: CaregiverNoteFlagEnum | null;
}

/** PaginatedResponse[ClientDoctorPopulated] */
export interface PaginatedResponseClientDoctorPopulated {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ClientDoctorPopulated[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** PaginatedResponse[Note] */
export interface PaginatedResponseNote {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: Note[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** PlaceDetailsResponse */
export interface PlaceDetailsResponse {
  /** Place Id */
  place_id: string;
  /** Formatted Address */
  formatted_address?: string | null;
  /** Address Components */
  address_components?: AddressComponent[];
  geometry?: PlaceGeometry;
}

/** PlaceGeometry */
export interface PlaceGeometry {
  location?: PlaceLocation;
}

/** PlaceLocation */
export interface PlaceLocation {
  /** Lat */
  lat?: number | null;
  /** Lng */
  lng?: number | null;
}

/** PlacePrediction */
export interface PlacePrediction {
  /** Place Id */
  place_id: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
  structured_formatting?: StructuredFormatting;
}

/** PlacesAutocompleteResponse */
export interface PlacesAutocompleteResponse {
  /** Predictions */
  predictions?: PlacePrediction[];
}

/** SearchGroup */
export interface SearchGroup {
  /** Entitytype */
  entityType: string;
  /** Total */
  total: number;
  /** Hasmore */
  hasMore: boolean;
  /** Items */
  items: SearchItem[];
}

/** SearchItem */
export interface SearchItem {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Subtitle */
  subtitle?: string | null;
  /** Sortat */
  sortAt?: string | null;
  /**
   * Inactive
   * @default false
   */
  inactive?: boolean;
  /** Status */
  status?: string | null;
  /**
   * Meta
   * @default {}
   */
  meta?: Record<string, any>;
  matched?: SearchMatched | null;
}

/** SearchMatched */
export interface SearchMatched {
  /** Label */
  label: string;
  /** Value */
  value: string;
}

/**
 * ServiceDb
 * Model representing the DB schema of a homecare service.
 */
export interface ServiceDb {
  /**
   * Name
   * Name of the specific service
   */
  name: string;
  /**
   * Description
   * Detailed description of the service offering
   */
  description?: string | null;
  /**
   * Servicetypeid
   * ID of the service type (foreign key to ServiceType table)
   */
  serviceTypeId: number;
  /**
   * Estimatedtimeminutes
   * Estimated time required to perform the service in minutes
   * @default 0
   */
  estimatedTimeMinutes?: number | null;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost?: number | null;
  /**
   * Price
   * Price of the service in Euros
   */
  price?: number | null;
  /**
   * Isexternalservice
   * Whether service is provided by a third party
   * @default false
   */
  isExternalService?: boolean;
  /**
   * Commissionexempt
   * Whether service is excluded from commission calculation (e.g., materials, medications)
   * @default false
   */
  commissionExempt?: boolean;
  /**
   * Isactive
   * Whether the service can be selected on new work. An inactive service is retired rather than deleted: it stops appearing in pickers but stays visible on the service requests and visits that already reference it, so history is preserved. Deleting instead would fail anyway - service_request_services and visit_services hold FKs with no cascade.
   * @default true
   */
  isActive?: boolean;
  /**
   * Serviceid
   * Unique identifier for the service (PK of services table)
   */
  serviceId: number;
}

/** StructuredFormatting */
export interface StructuredFormatting {
  /**
   * Main Text
   * @default ""
   */
  main_text?: string;
  /** Secondary Text */
  secondary_text?: string | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** VisitAttachmentsPaginatedResponse */
export interface VisitAttachmentsPaginatedResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: AttachmentBase[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** VisitHistory */
export interface VisitHistory {
  /** Visitid */
  visitId: number;
  /** Caregivers */
  caregivers?: CaregiverServiceRequestResponse[] | null;
  /** Starttime */
  startTime?: string | null;
  /** Endtime */
  endTime?: string | null;
  /** Completedat */
  completedAt?: string | null;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /** Services */
  services?: ServiceDb[] | null;
  /** Attachments */
  attachments?: any[] | null;
}

/**
 * ClientDoctorCreate
 * Payload for POST /client-doctors — create a new client-doctor relationship
 */
export interface HomecareModelsClientDoctorsClientDoctorCreate {
  /**
   * Clientid
   * ID of the client
   */
  clientId: number;
  /**
   * Doctorid
   * ID of the doctor
   */
  doctorId: number;
  /** Type of doctor (ATTENDING or REFERRING) */
  doctorType: DoctorTypeEnum;
  /**
   * Startdate
   * Start date of the doctor-client relationship
   * @format date
   */
  startDate: string;
  /**
   * Enddate
   * End date of the relationship (NULL if active)
   */
  endDate?: string | null;
  /**
   * Takescommission
   * Whether this client-doctor assignment pays commission for the covered period
   * @default true
   */
  takesCommission?: boolean;
  /**
   * Commissionrate
   * Commission percentage override for this assignment period (0-100). NULL falls back to doctor default
   */
  commissionRate?: number | null;
}

/**
 * ClientDoctorCreate
 * Payload for creating a client-doctor relationship
 */
export interface HomecareModelsClientsClientDoctorCreate {
  /**
   * Doctorid
   * ID of the doctor
   */
  doctorId: number;
  /** Type of doctor (ATTENDING or REFERRING) */
  doctorType: DoctorTypeEnum;
  /**
   * Startdate
   * Start date of the doctor-client relationship
   * @format date
   */
  startDate: string;
  /**
   * Enddate
   * End date of the relationship (NULL if active)
   */
  endDate?: string | null;
  /**
   * Takescommission
   * Whether this client-doctor assignment pays commission for the covered period
   * @default true
   */
  takesCommission?: boolean;
  /**
   * Commissionrate
   * Commission percentage override for this assignment period (0-100). NULL falls back to doctor default
   */
  commissionRate?: number | null;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api/v1/clients-api/',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title clients
 * @version 1.0.0
 * @baseUrl /api/v1/clients-api/
 *
 *
 * Microservice for managing home care clients.
 *
 * ## Features
 * * Create, read, update, and delete client records
 * * Manage client addresses and emergency contacts
 * * Manage client attachments (documents, images)
 * * Manage client-doctor relationships with historical tracking
 * * Secure endpoints with authentication and authorization
 *
 * ## Authentication
 * All endpoints require authentication using JWT tokens.
 * Admin endpoints require additional admin permissions.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  notes = {
    /**
     * @description Records that the calling user has read these notes. A note that was already read, or that the caller cannot see, is skipped rather than refused, so `marked` may be lower than the number of ids sent.
     *
     * @tags Notes
     * @name MarkNotesRead
     * @summary Marks a batch of notes read
     * @request POST:/notes/read
     * @secure
     */
    markNotesRead: (data: NoteReadRequest, params: RequestParams = {}) =>
      this.request<NoteReadResult, void | HTTPValidationError>({
        path: `/notes/read`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Notes visible to the caller that they have not read and did not write. Pass `client_id` to narrow the count to one client.
     *
     * @tags Notes
     * @name GetNotesUnreadCount
     * @summary Counts the caller's unread notes
     * @request GET:/notes/unread-count
     * @secure
     */
    getNotesUnreadCount: (
      query?: {
        /**
         * Client Id
         * Narrow the count to one client
         */
        client_id?: number | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<NoteUnreadCount, void | HTTPValidationError>({
        path: `/notes/unread-count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description `body` may be changed by the note's AUTHOR and by nobody else. `flag` may be set by anyone the policies let update the row, which is how a coordinator says how a caregiver's note reads without rewriting a word of it. Asking for the wrong one of the two is a 403 from the database, not a silent no-op.
     *
     * @tags Notes
     * @name UpdateNote
     * @summary Edits a note
     * @request PATCH:/notes/{note_id}
     * @secure
     */
    updateNote: (noteId: number, data: NoteUpdate, params: RequestParams = {}) =>
      this.request<Note, void | HTTPValidationError>({
        path: `/notes/${noteId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description The author may delete their own note; an administrator may delete any note they can see. A note that is absent and one that is invisible are the same 404 on purpose - reporting 'forbidden' would confirm that a note exists to someone who may not read it.
     *
     * @tags Notes
     * @name DeleteNote
     * @summary Deletes a note
     * @request DELETE:/notes/{note_id}
     * @secure
     */
    deleteNote: (noteId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/notes/${noteId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  clients = {
    /**
     * @description The client's note stream, newest first and tie-broken by note id so paging can neither drop a note nor show one twice. Pass `visit_id` for the notes of one visit, or `client_level_only=true` for the ones tied to no visit at all - a standing instruction every caregiver on the client sees. The two cannot be combined. Which notes come back is decided by each note's audience and by the caller's scope over the client, in the database. Two callers asking the same question legitimately get different pages.
     *
     * @tags Notes
     * @name ListClientNotes
     * @summary Lists a client's notes
     * @request GET:/clients/{client_id}/notes
     * @secure
     */
    listClientNotes: (
      clientId: number,
      query?: {
        /**
         * Visit Id
         * Restrict to one visit
         */
        visit_id?: number | null;
        /**
         * Client Level Only
         * Restrict to notes tied to no visit. Cannot be combined with `visit_id`.
         * @default false
         */
        client_level_only?: boolean;
        /**
         * Kind
         * Restrict to VISIT_NOTE or MESSAGE
         */
        kind?: NoteKindEnum | null;
        /**
         * Flag
         * Filter by how the note is classified. Repeatable; a note matches if it carries any of the values given.
         */
        flag?: CaregiverNoteFlagEnum[] | null;
        /**
         * Unflagged Only
         * Restrict to notes nothing has classified yet. Cannot be combined with `flag`.
         * @default false
         */
        unflagged_only?: boolean;
        /**
         * Author Role
         * Restrict to notes written in one of these roles. Repeatable.
         */
        author_role?: NoteRoleEnum[] | null;
        /**
         * Unread Only
         * Restrict to notes the caller has not read and did not write
         * @default false
         */
        unread_only?: boolean;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaginatedResponseNote, void | HTTPValidationError>({
        path: `/clients/${clientId}/notes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Files a note under the client. Omit `visitId` for a client-level note, or name a visit OF THIS CLIENT for one about a visit - a visit belonging to someone else is refused by the database, not filed under the wrong timeline. The author is the calling user in the role their session is running as; neither can be set from the body. `audience` decides who may read the note and defaults to everyone who can be on the visit.
     *
     * @tags Notes
     * @name CreateClientNote
     * @summary Writes a note about a client
     * @request POST:/clients/{client_id}/notes
     * @secure
     */
    createClientNote: (clientId: number, data: NoteCreate, params: RequestParams = {}) =>
      this.request<Note, void | HTTPValidationError>({
        path: `/clients/${clientId}/notes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of clients with support for both free-text search and advanced JSON:API filters. You can combine both search queries and filters to narrow down results. **Free-text search:** - Use 'query' parameter (min 3 chars) to search by first name, last name, mobile/home phone, email, or address (street, city, postal code) **Advanced filters:** - Use JSON:API filter syntax: filter[field]=value - Supports complex filters with OR/AND logic **Pagination:** - /clients?page[offset]=0&page[limit]=10 - /clients?page[number]=1&page[size]=10 **Sorting:** - /clients?sort=-last_name,first_name - Prefix with '-' for descending order **Combined example:** - /clients?query=john&filter[city]=Athens&sort=-created_at
     *
     * @tags Clients
     * @name ListClients
     * @summary Get clients with search and advanced filtering
     * @request GET:/clients
     * @secure
     */
    listClients: (
      query?: {
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'last_name,-created_at'. Prefix with '-' for DESC.
         * @default "client_id"
         */
        sort?: string | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ClientsGetAllPaginationResponse, void | HTTPValidationError>({
        path: `/clients`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new client record with address and optional emergency contact
     *
     * @tags Clients
     * @name CreateClient
     * @summary Create new client
     * @request POST:/clients
     * @secure
     */
    createClient: (data: ClientCreate, params: RequestParams = {}) =>
      this.request<Client, void | HTTPValidationError>({
        path: `/clients`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportClients
     * @summary Export the clients list
     * @request POST:/clients/export
     * @secure
     */
    exportClients: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/clients/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportClientsTemplate
     * @summary Import template for the clients list
     * @request GET:/clients/import/template
     * @secure
     */
    importClientsTemplate: (params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/clients/import/template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportClientsPreview
     * @summary Check an import of the clients list without saving
     * @request POST:/clients/import/preview
     * @secure
     */
    importClientsPreview: (data: BodyImportClientsPreview, params: RequestParams = {}) =>
      this.request<ImportReport, void | HTTPValidationError>({
        path: `/clients/import/preview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportClientsCommit
     * @summary Import into the clients list, all rows or none
     * @request POST:/clients/import/commit
     * @secure
     */
    importClientsCommit: (data: BodyImportClientsCommit, params: RequestParams = {}) =>
      this.request<ImportReport, void | ImportReport | HTTPValidationError>({
        path: `/clients/import/commit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of clients. Optionally provide a 'query' (min 3 chars) to search by first name, last name, mobile/home phone, email, or address (street, city, postal code).
     *
     * @tags Clients
     * @name ListClientsMinified
     * @summary Get clients (list or search) with minified schema
     * @request GET:/clients/minified
     * @secure
     */
    listClientsMinified: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ClientsGetAllMinifiedPaginationResponse, void | HTTPValidationError>({
        path: `/clients/minified`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a specific client by their ID
     *
     * @tags Clients
     * @name GetClientById
     * @summary Get client by ID
     * @request GET:/clients/{client_id}
     * @secure
     */
    getClientById: (clientId: number, params: RequestParams = {}) =>
      this.request<ClientPopulated, void | HTTPValidationError>({
        path: `/clients/${clientId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing client's information
     *
     * @tags Clients
     * @name UpdateClient
     * @summary Update client
     * @request PUT:/clients/{client_id}
     * @secure
     */
    updateClient: (clientId: number, data: ClientUpdate, params: RequestParams = {}) =>
      this.request<ClientPopulated, void | HTTPValidationError>({
        path: `/clients/${clientId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a client record by ID
     *
     * @tags Clients
     * @name DeleteClient
     * @summary Delete client
     * @request DELETE:/clients/{client_id}
     * @secure
     */
    deleteClient: (clientId: string, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/clients/${clientId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Apply the same set of field changes to several clients in one transaction
     *
     * @tags Clients
     * @name BulkUpdateClients
     * @summary Bulk update clients
     * @request PATCH:/clients/bulk
     * @secure
     */
    bulkUpdateClients: (data: ClientBulkUpdateRequest, params: RequestParams = {}) =>
      this.request<ClientBulkUpdateResponse, void | HTTPValidationError>({
        path: `/clients/bulk`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a client along with their complete visit history, with optional date range filtering
     *
     * @tags Clients
     * @name GetClientHistory
     * @summary Get a client with their full visit history
     * @request GET:/clients/history/{client_id}
     * @secure
     */
    getClientHistory: (
      clientId: string,
      query?: {
        /**
         * Start Date
         * Filter visit history on or after this date
         */
        start_date?: string | null;
        /**
         * End Date
         * Filter visit history on or before this date
         */
        end_date?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ClientWithHistory, void | HTTPValidationError>({
        path: `/clients/history/${clientId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve an AI-generated summary of a client's case based on their visit history
     *
     * @tags Clients
     * @name GetClientAiSummary
     * @summary Get AI-generated summary for a client
     * @request GET:/clients/ai-summary/{client_id}
     * @secure
     */
    getClientAiSummary: (clientId: number, params: RequestParams = {}) =>
      this.request<string, void | HTTPValidationError>({
        path: `/clients/ai-summary/${clientId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lists all attachments for a specific client.
     *
     * @tags Client Attachments
     * @name ListClientAttachments
     * @summary List all attachments for a client
     * @request GET:/clients/{client_id}/attachments
     * @secure
     */
    listClientAttachments: (
      clientId: number,
      query?: {
        /**
         * Offset
         * The number of records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitAttachmentsPaginatedResponse, void | HTTPValidationError>({
        path: `/clients/${clientId}/attachments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Adds an attachment to a specific client. Supported file types: txt, csv, pdf, and images (jpg, jpeg, png, gif, bmp, webp). Maximum file size: 20MB.
     *
     * @tags Client Attachments
     * @name CreateClientAttachment
     * @summary Add an attachment to a client
     * @request POST:/clients/{client_id}/attachments
     * @secure
     */
    createClientAttachment: (clientId: number, data: BodyCreateClientAttachment, params: RequestParams = {}) =>
      this.request<AttachmentCreateResponse, void | HTTPValidationError>({
        path: `/clients/${clientId}/attachments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Downloads the content of a client attachment.
     *
     * @tags Client Attachments
     * @name DownloadClientAttachment
     * @summary Download a client attachment
     * @request GET:/clients/{client_id}/attachments/{attachment_id}/download
     * @secure
     */
    downloadClientAttachment: (clientId: number, attachmentId: number, params: RequestParams = {}) =>
      this.request<AttachmentWithContent, void | HTTPValidationError>({
        path: `/clients/${clientId}/attachments/${attachmentId}/download`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Changes an attachment's kind and/or description. The file itself is immutable - replacing its content means uploading a new one. Only the fields present in the body are written, so omitting `kind` leaves it alone and sending `null` clears it.
     *
     * @tags Client Attachments
     * @name UpdateClientAttachment
     * @summary Update how an attachment is described
     * @request PATCH:/clients/{client_id}/attachments/{attachment_id}
     * @secure
     */
    updateClientAttachment: (
      clientId: number,
      attachmentId: number,
      data: AttachmentUpdate,
      params: RequestParams = {}
    ) =>
      this.request<void, void | HTTPValidationError>({
        path: `/clients/${clientId}/attachments/${attachmentId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes a client attachment by its ID.
     *
     * @tags Client Attachments
     * @name DeleteClientAttachment
     * @summary Delete an attachment by ID
     * @request DELETE:/clients/{client_id}/attachments/{attachment_id}
     * @secure
     */
    deleteClientAttachment: (clientId: number, attachmentId: number, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError | void>({
        path: `/clients/${clientId}/attachments/${attachmentId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves all doctor relationships for a client with pagination support
     *
     * @tags Client Doctors
     * @name GetClientDoctorsByClient
     * @summary Get all doctors for a specific client
     * @request GET:/clients/{client_id}/doctors
     * @secure
     */
    getClientDoctorsByClient: (
      clientId: number,
      query?: {
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaginatedResponseClientDoctorPopulated, HTTPValidationError>({
        path: `/clients/${clientId}/doctors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves only active doctor relationships (end_date is NULL or in the future) for a client
     *
     * @tags Client Doctors
     * @name GetActiveClientDoctors
     * @summary Get active doctors for a specific client
     * @request GET:/clients/{client_id}/doctors/active
     * @secure
     */
    getActiveClientDoctors: (clientId: number, params: RequestParams = {}) =>
      this.request<ClientDoctorPopulated[], HTTPValidationError>({
        path: `/clients/${clientId}/doctors/active`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  health = {
    /**
     * @description Returns the health status of the client-doctors service
     *
     * @tags Health
     * @name GetClientDoctorsServiceHealth
     * @summary Health check endpoint for client-doctors
     * @request GET:/health
     * @secure
     */
    getClientDoctorsServiceHealth: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  byUser = {
    /**
     * @description Retrieve a client by their user ID
     *
     * @tags Clients
     * @name GetClientByUserId
     * @summary Get client by user ID
     * @request GET:/by-user/{user_id}
     * @secure
     */
    getClientByUserId: (userId: number, params: RequestParams = {}) =>
      this.request<ClientPopulated, void | HTTPValidationError>({
        path: `/by-user/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  clientDoctors = {
    /**
     * @description Creates a new relationship between a client and a doctor with type (ATTENDING or REFERRING) and date range
     *
     * @tags Client Doctors
     * @name CreateClientDoctor
     * @summary Create a new client-doctor relationship
     * @request POST:/client-doctors
     * @secure
     */
    createClientDoctor: (data: HomecareModelsClientDoctorsClientDoctorCreate, params: RequestParams = {}) =>
      this.request<ClientDoctorPopulated, HTTPValidationError>({
        path: `/client-doctors`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a paginated list of client-doctor relationships with support for advanced JSON:API filters. **Advanced filters:** - Use JSON:API filter syntax: filter[field]=value - Supports complex filters with OR/AND logic - filter[is_active]=true - returns only active relationships **Pagination:** - /client-doctors?page[offset]=0&page[limit]=10 - /client-doctors?page[number]=1&page[size]=10 **Sorting:** - /client-doctors?sort=-start_date,doctor_type - Prefix with '-' for descending order **Examples:** - /client-doctors?filter[client_id]=123&filter[is_active]=true - /client-doctors?filter[doctor_type]=ATTENDING&sort=-start_date
     *
     * @tags Client Doctors
     * @name GetFilteredClientDoctors
     * @summary Get client-doctors with advanced filtering
     * @request GET:/client-doctors
     * @secure
     */
    getFilteredClientDoctors: (
      query?: {
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaginatedResponseClientDoctorPopulated, HTTPValidationError>({
        path: `/client-doctors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a specific client-doctor relationship with populated doctor information
     *
     * @tags Client Doctors
     * @name GetClientDoctor
     * @summary Get a client-doctor relationship by ID
     * @request GET:/client-doctors/{client_doctor_id}
     * @secure
     */
    getClientDoctor: (clientDoctorId: number, params: RequestParams = {}) =>
      this.request<ClientDoctorPopulated, HTTPValidationError>({
        path: `/client-doctors/${clientDoctorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates an existing client-doctor relationship. All fields are optional.
     *
     * @tags Client Doctors
     * @name UpdateClientDoctor
     * @summary Update a client-doctor relationship
     * @request PATCH:/client-doctors/{client_doctor_id}
     * @secure
     */
    updateClientDoctor: (clientDoctorId: number, data: ClientDoctorUpdate, params: RequestParams = {}) =>
      this.request<ClientDoctorPopulated, HTTPValidationError>({
        path: `/client-doctors/${clientDoctorId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a client-doctor relationship. Returns the ID of the deleted relationship.
     *
     * @tags Client Doctors
     * @name DeleteClientDoctor
     * @summary Delete a client-doctor relationship
     * @request DELETE:/client-doctors/{client_doctor_id}
     * @secure
     */
    deleteClientDoctor: (clientDoctorId: number, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/client-doctors/${clientDoctorId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  clientCategories = {
    /**
     * @description Free text query; if not given return all; if given (>3 chars) searches
     *
     * @tags Client Categories
     * @name ListClientCategories
     * @summary Get client categories (list or search)
     * @request GET:/client-categories
     * @secure
     */
    listClientCategories: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'name,-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ClientCategoriesGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/client-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new client category record
     *
     * @tags Client Categories
     * @name CreateClientCategory
     * @summary Create new client category
     * @request POST:/client-categories
     * @secure
     */
    createClientCategory: (data: ClientCategoryCreate, params: RequestParams = {}) =>
      this.request<ClientCategory, void | HTTPValidationError>({
        path: `/client-categories`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportClientCategories
     * @summary Export the client_categories list
     * @request POST:/client-categories/export
     * @secure
     */
    exportClientCategories: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/client-categories/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a specific client category by its ID
     *
     * @tags Client Categories
     * @name GetClientCategoryById
     * @summary Get client category by ID
     * @request GET:/client-categories/{client_category_id}
     * @secure
     */
    getClientCategoryById: (clientCategoryId: number, params: RequestParams = {}) =>
      this.request<ClientCategory, void | HTTPValidationError>({
        path: `/client-categories/${clientCategoryId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing client category's information
     *
     * @tags Client Categories
     * @name UpdateClientCategory
     * @summary Update client category
     * @request PUT:/client-categories/{client_category_id}
     * @secure
     */
    updateClientCategory: (clientCategoryId: number, data: ClientCategoryUpdate, params: RequestParams = {}) =>
      this.request<ClientCategory, void | HTTPValidationError>({
        path: `/client-categories/${clientCategoryId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a client category record by ID
     *
     * @tags Client Categories
     * @name DeleteClientCategory
     * @summary Delete client category
     * @request DELETE:/client-categories/{client_category_id}
     * @secure
     */
    deleteClientCategory: (clientCategoryId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/client-categories/${clientCategoryId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  places = {
    /**
     * @description Proxy for Google Places Autocomplete. Returns address predictions for the given input. The Google API key stays server-side.
     *
     * @tags Places
     * @name PlacesAutocomplete
     * @summary Address autocomplete
     * @request GET:/places/autocomplete
     * @secure
     */
    placesAutocomplete: (
      query: {
        /**
         * Input
         * Text to search for
         * @minLength 1
         */
        input: string;
        /**
         * Language
         * Result language
         * @default "el"
         */
        language?: string;
        /**
         * Components
         * Google components filter, e.g. 'country:gr'
         * @default "country:gr"
         */
        components?: string | null;
        /**
         * Types
         * Place types filter
         * @default "address"
         */
        types?: string;
        /**
         * Sessiontoken
         * Google session token for billing grouping
         */
        sessiontoken?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<PlacesAutocompleteResponse, HTTPValidationError | void>({
        path: `/places/autocomplete`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Proxy for Google Place Details. Returns the formatted address, address components and geometry for a place id from autocomplete.
     *
     * @tags Places
     * @name PlaceDetails
     * @summary Place details
     * @request GET:/places/details/{place_id}
     * @secure
     */
    placeDetails: (
      placeId: string,
      query?: {
        /**
         * Language
         * Result language
         * @default "el"
         */
        language?: string;
        /**
         * Sessiontoken
         * Google session token for billing grouping
         */
        sessiontoken?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<PlaceDetailsResponse, void | HTTPValidationError>({
        path: `/places/details/${placeId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  search = {
    /**
     * @description Office only. Every word must match; results grouped by entity type.
     *
     * @tags Search
     * @name GlobalSearch
     * @summary Global search across office entities
     * @request GET:/search
     * @secure
     */
    globalSearch: (
      query: {
        /**
         * Q
         * @minLength 1
         * @maxLength 200
         */
        q: string;
        /**
         * Types
         * Entity types the dashboard has enabled
         * @minItems 1
         */
        types: string[];
        /**
         * Per Group
         * @min 1
         * @max 20
         * @default 5
         */
        per_group?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<GlobalSearchResponse, HTTPValidationError>({
        path: `/search`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
